import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { 
  MsalInterceptorConfiguration, 
  MsalInterceptor, 
  MsalService, 
  MsalGuard, 
  MsalBroadcastService,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG
} from '@azure/msal-angular';
import { PublicClientApplication, BrowserCacheLocation, InteractionType, IPublicClientApplication } from '@azure/msal-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { loggingInterceptor } from './interceptors/logging.interceptor';

const apiScopes = ['api://c44bf44b-17ab-436b-ab84-82b4425c90b3/api.read'];
const graphScopes = ['user.read'];

const msalConfig = {
  auth: {
    clientId: 'bc44699a-e271-460d-866b-6e06917bffd9',
    authority: 'https://login.microsoftonline.com/5fad863f-528e-4b20-b0d7-ec0329f09796',
    redirectUri: `${window.location.origin}/`,
    postLogoutRedirectUri: `${window.location.origin}/`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
};

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

// Redirect (not Popup): guard-triggered popups render the app's own route since redirectUri is the app root
const msalGuardConfig = {
  interactionType: InteractionType.Redirect,
  authRequest: {
    scopes: apiScopes
  }
};

const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
    ['https://graph.microsoft.com/v1.0/me', graphScopes],
    ['https://localhost:44392', apiScopes],
  ])
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([loggingInterceptor]),
      withInterceptorsFromDi()
    ),
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useValue: msalGuardConfig
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useValue: msalInterceptorConfig
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    }
  ]
};

